import { useEffect, useRef, useState } from "react";

/* Mobile: horizontal snap carousel with dots. ≥sm: regular responsive grid. */
export function SwipeDeck({ children, count, testid = "swipe-deck" }) {
  const ref = useRef(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const card = el.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16;
      setIndex(Math.min(count - 1, Math.max(0, Math.round(el.scrollLeft / step))));
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [count]);

  const goTo = (i) => {
    const el = ref.current;
    const card = el?.children[i];
    if (card) el.scrollTo({ left: card.offsetLeft - el.offsetLeft, behavior: "smooth" });
  };

  return (
    <div data-testid={testid}>
      <div ref={ref} className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 lg:grid-cols-3 [&>*]:w-[84%] [&>*]:shrink-0 [&>*]:snap-center sm:[&>*]:w-auto" data-testid={`${testid}-track`}>
        {children}
      </div>
      {count > 1 && (
        <div className="mt-2 flex justify-center gap-1.5 sm:hidden" data-testid={`${testid}-dots`}>
          {Array.from({ length: count }).map((_, i) => (
            <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Go to card ${i + 1}`} aria-current={i === index ? "true" : undefined}
              className={`h-1.5 rounded-full transition-all ${i === index ? "w-5 bg-primary" : "w-1.5 bg-border"}`} data-testid={`${testid}-dot-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
}
